<section class="connect-page user-management-page">
    <div class="page-heading">
        <div>
            <p class="connect-section-title">Users</p>
            <h1>User access</h1>
            <p class="connect-subtitle">
                Read-only user and module access for {{ selectedClient.name || 'the selected client' }}.
            </p>
        </div>
        <div class="summary-pills" aria-label="Rights summary">
            <span class="connect-chip neutral">Rights v{{ rightsVersion ?? '-' }}</span>
            <span class="connect-chip success">{{ adminUserCount }} admin user{{ adminUserCount === 1 ? '' : 's' }}</span>
            <span class="connect-chip neutral">{{ totalModuleCount }} module grant{{ totalModuleCount === 1 ? '' : 's' }}</span>
        </div>
    </div>

    @if (state === 'loading') {
        <mat-card class="connect-card state-card" data-testid="users-loading">
            <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
            <span class="connect-muted">Loading users...</span>
        </mat-card>
    } @else if (state === 'unauthorized') {
        <mat-card class="connect-card state-card state-card--warn" data-testid="users-unauthorized">
            <i-tabler name="lock" class="icon-24"></i-tabler>
            <div>
                <h2>Access denied</h2>
                <p class="connect-muted">This page is available to Shine admins for the selected client.</p>
            </div>
        </mat-card>
    } @else if (state === 'error') {
        <mat-card class="connect-card state-card state-card--error" data-testid="users-error">
            <i-tabler name="settings" class="icon-24"></i-tabler>
            <div>
                <h2>Could not load access</h2>
                <p class="connect-muted">Refresh or try again later. Nothing was changed.</p>
            </div>
            <button mat-stroked-button color="primary" (click)="loadUsers()">Refresh</button>
        </mat-card>
    } @else if (state === 'empty') {
        <mat-card class="connect-card state-card" data-testid="users-empty">
            <i-tabler name="users" class="icon-24"></i-tabler>
            <div>
                <h2>No users found</h2>
                <p class="connect-muted">No cached user access rows are available for this client.</p>
            </div>
        </mat-card>
    } @else {
        <mat-card class="connect-card users-table-card" data-testid="users-ready">
            <mat-card-header>
                <div class="client-title">
                    <div class="client-avatar" aria-hidden="true">
                        <i-tabler name="building" class="icon-22"></i-tabler>
                    </div>
                    <div>
                        <mat-card-title>{{ selectedClient.name }}</mat-card-title>
                        <mat-card-subtitle>{{ selectedClient.domain || selectedClient.id }}</mat-card-subtitle>
                    </div>
                </div>
            </mat-card-header>

            <mat-card-content>
                <div class="users-table" role="table" aria-label="Read-only client users">
                    <div class="users-table__header" role="row">
                        <span role="columnheader">User</span>
                        <span role="columnheader">Access</span>
                        <span role="columnheader">Modules</span>
                        <span role="columnheader">Enabled products</span>
                    </div>

                    @for (user of users; track trackUser($index, user)) {
                        <div class="user-row" role="row">
                            <div class="user-cell user-identity" role="cell">
                                <span class="user-email">{{ user.email }}</span>
                                <span class="connect-muted">{{ user.id }}</span>
                            </div>
                            <div class="user-cell" role="cell">
                                <span [ngClass]="accessBadge(user.access).className">{{ accessBadge(user.access).label }}</span>
                            </div>
                            <div class="user-cell chip-list" role="cell">
                                @if (user.moduleAccess.length === 0) {
                                    <span class="connect-muted">No module grants</span>
                                } @else {
                                    @for (access of user.moduleAccess; track trackAccess($index, access)) {
                                        <span class="access-token">
                                            {{ access.name }}
                                            <span [ngClass]="accessBadge(access.access).className">{{ accessBadge(access.access).label }}</span>
                                        </span>
                                    }
                                }
                            </div>
                            <div class="user-cell chip-list" role="cell">
                                @if (user.enabledProducts.length === 0) {
                                    <span class="connect-muted">No enabled products</span>
                                } @else {
                                    @for (product of user.enabledProducts; track trackAccess($index, product)) {
                                        <span class="access-token">
                                            {{ product.name }}
                                            <span [ngClass]="accessBadge(product.access).className">{{ accessBadge(product.access).label }}</span>
                                        </span>
                                    }
                                }
                            </div>
                        </div>
                    }
                </div>
            </mat-card-content>
        </mat-card>
    }
</section>
